<template>
  <div :id="id" :style="size"></div>
</template>

<style scoped>
</style>

<script>
import GhChart from "./ghChart.ts";
export default GhChart;
</script>